  import DataAnalytics from '../Assests/data.jpg'
  import DataAnalysis from "../Assests/dataanalysis.jpg"
  import ML from "../Assests/ML.jpg"
  import NLP from "../Assests/Nlp.jpg"
  import Docker from "../Assests/Docker.jpg"
  import Pipeline from "../Assests/pipeline.jpg"
  
  const Projects = [
    {
      id: 1,
      ImageSrc: DataAnalysis,
      title: 'Data Analysis',
      description: 'Implemented data analysis projects with interactive Streamlit UI for user-friendly data exploration and insights presentation',
      skills: ["Python","Pandas","Tableau"],
      sourceLink: 'https://github.com/praveendecode/Data-Analysis',
    },
    {
      id: 2,
      ImageSrc: ML,
      title: 'Machine Learning',
      description: 'Showcasing Machine Learning projects to highlight my skills in different applications, algorithms, and techniques',
      skills: ["Python","Scikit-Learn","Azure"],
      sourceLink: 'https://github.com/praveendecode/Machine_Learning',
    },
    {
      id: 3,
      ImageSrc: NLP,
      title: 'NLP',
      description: 'Showcasing NLP projects exploring OCR, summarization, TableQA, translation, sentiment analysis.',
      skills: ["Python","Hugging Face"],
      sourceLink: 'https://github.com/praveendecode/Natural_Language_Processing',
    },
    {
      id: 4,
      ImageSrc: Docker,
      title: 'Docker',
      description: 'Deployed ML and NLP apps as Docker images for seamless, scalable execution across diverse computing environments',
      skills: ["Docker Image","Docker Container"],
      sourceLink: 'https://github.com/praveendecode/Docker',
      liveLink: 'https://hub.docker.com/u/praveendecode'
    },
    {
      id: 5,
      ImageSrc: Pipeline,
      title: 'Pipeline',
      description: 'Implemented ETL projects with interactive Streamlit UI for user-friendly data extraction, transformation, and loading tasks',
      skills: ["SQL","Python","API Integration"],
      sourceLink: 'https://github.com/praveendecode/Data_Pipeline'
    },
    {
      id: 6,
      ImageSrc: DataAnalytics,
      title: 'IBM Data Analytics',
      description: 'Analytics for Hospitals Health-Care Data, Utilized various data visualization and statistical analysis in IBM',
      skills: ["IBM Cognos","Data Visualization"],
      sourceLink: 'https://github.com/praveendecode/Analytics-for-Hospitals-Health-Care-Data'
    }
  ]

export default Projects